<template>
  <div class="filter-modal-wrapper" v-if="visible">
    <i class="mask" />
    <div class="filter-modal">
      <div class="filter-list">
        <section :class="['filter-item', filterItem.class]" v-for="filterItem in filterItems">
          <label class="filter-title">{{filterItem.title}}</label>
          <div v-if="filterItem.isSelectAll || filterItem.isSearch" class="filter-extra-operation">
            <div class="filter-input-wrapper">
              <input class="filter-input" v-model="filterValue[filterItem.key]" />
              <i v-if="filterValue[filterItem.key]" class="filter-clear" @click="onClearFilter(filterItem.key)" />
            </div>

            <div v-if="filterItem.isSelectAll" class="select-all">
              <span class="radio-btn" @click="onSelectAll(filterItem, true)">全选</span>
              <span class="radio-btn" @click="onSelectAll(filterItem, false)">全不选</span>
            </div>
          </div>
          <ul class="option-list">
            <li
            v-for="item in (filterMetaParams[filterItem.key] || metaParams[filterItem.key])"
            :class="['option-item', filterParams[filterItem.key].includes(item[filterItem.keyName] || item) ? 'active' : '']"
            @click="onChangeOption(filterItem.key, item[filterItem.keyName] || item)"
            >{{item[filterItem.valueName] || item}}</li>
          </ul>
        </section>
      </div>

      <section class="footer-btn">
        <span class="submit-btn" @click="onSubmit">确认</span>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterModal',
  components: {

  },
  props: {
    visible: Boolean,
    metaParams: Object,
    filterParams: Object,
  },
  data() {
    return {
      filterMetaParams: {
        providers: undefined,
      },
      filterValue: {
        providers: '',
      },
      filterItems: [
        {
          key: 'businessTypes',
          title: '业务类型'
        },
        // {
        //   key: 'onlineTypes',
        //   title: '新老客户'
        // },
        {
          key: 'providerTypes',
          title: '合作方类型'
        },
        {
          key: 'providers',
          title: '单个读书会',
          class: 'block',
          keyName: 'providerId',
          valueName: 'readableName',
          isSelectAll: true,
          isSearch: true,
        },
      ]
    }
  },
  methods: {
    onChangeOption: function (key, value) {
      this.$emit('on-change-filter', { key, value })
    },
    onSubmit: function () {
      this.$emit('on-submit')
    },
    onSelectAll: function (item, isSelectAll) {
      const value = this.metaParams[item.key].map((dataItem) => {
        return item.keyName ? dataItem[item.keyName] : dataItem;
      })
      this.$emit('on-change-filter', {
        key: item.key,
        value: isSelectAll ? value : [],
        isMultiUpdate: true,
      })
    },
    onClearFilter: function (key) {
      this.filterValue[key] = ''
    }
  },
  watch: {
    // 'filterValue': {
    //   deep: true,
    //   handler: function (val, oldVal) {
    //     Object.keys(val).forEach((key) => {
    //       if (val[key]) {
    //         this.filterValue[key] = this.metaParams[key].filter((item) => {
    //           this.
    //         })
    //       }
    //     })
    //   },
    // }
    'filterValue.providers': function (val) {
      if (val) {
        this.filterMetaParams.providers = this.metaParams.providers.filter((item) => {
          return item.readableName.indexOf(val) > -1
        })
      } else {
        this.filterMetaParams.providers = undefined
      }
    }
  }
};
</script>

<style scoped lang="scss">
.filter-modal-wrapper {
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 100;
  }

  .filter-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 300px;
    height: 400px;
    margin: auto;
    background-color: #fff;
    z-index: 101;
    padding: 10px;
    display: flex;
    flex-direction: column;
  }

  .filter-item {
    position: relative;
    display: flex;
    padding: 10px 0;
    font-size: 14px;
    line-height: 24px;
    border-bottom: 1px solid #f0f0f0;

    .filter-extra-operation {
      position: relative;
      height: 30px;
    }

    .filter-input-wrapper {
      display: inline-block;
      position: relative;
    }

    .filter-clear {
      position: absolute;
      display: inline-block;
      width: 14px;
      height: 14px;
      top: 8px;
      right: 4px;
      background-image: url('../../assets/filter_close.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

    .filter-input {
      height: 20px;
      width: 150px;
      margin-top: 5px;
      padding: 0 5px;
      line-height: 20px;
      font-size: 14px;
      border: 1px solid #f0f0f0;
      box-shadow: none;

      &:focus {
        outline: none;
      }
    }

    .select-all {
      position: absolute;
      top: 5px;
      right: 0;
      font-size: 0;
    }

    .radio-btn {
      font-size: 12px;
      line-height: 20px;
      display: inline-block;
      padding: 0 10px;
      background-color: #e51c23;
      margin-left: 10px;
      color: #fff;
    }

    &.block {
      flex-direction: column;

      .option-item {
        width: 100%;
      }

      .option-list {
        padding-left: 5px;
      }
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  .filter-title {
    flex-grow: 0;
    flex-shrink: 0;
    margin: 0;
    color: #787878;
    width: 5.2em;
    margin-right: 8px;
    text-align: right;
  }

  .option-list {
    flex-grow: 1;
    flex-shrink: 1;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .option-item {
    display: inline-block;
    padding-left: 20px;
    width: 80px;
    background-image: url('../../assets/checkbox.png');
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 14px;
    white-space: nowrap;

    &.active {
      background-image: url('../../assets/checkbox_active.png');
    }
  }

  .filter-list {
    overflow-y: auto;
    flex-grow: 1;
    flex-shrink: 1;
  }

  .footer-btn {
    padding-top: 10px;
    text-align: right;
    background-color: #fff;
  }

  .submit-btn {
    display: inline-block;
    background-color: #e51c23;
    color: #fff;
    font-size: 14px;
    line-height: 30px;
    width: 80px;
    text-align: center;
  }
}
</style>
